import { defineMessages } from "@edx/frontend-platform/i18n";

const messages = defineMessages({
  "progressTitle": {
    id: "dashboard.page.progress",
    defaultMessage: "Progress",
    description: "Progress page title"
  },
  "seeProgress": {
    id: "dashboard.page.seeProgress",
    defaultMessage: "See Progress",
    description: "See Progress button"
  },
  "updatesTitle": {
    id: "dashboard.page.updates",
    defaultMessage: "Updates",
    description: "Updates title"
  },
  "recentActivityTitle": {
    id: "dashboard.page.recentActivity",
    defaultMessage: "Recent Activity",
    description: "Recent Activity title"
  },
  "seeMyFeed": {
    id: "dashboard.page.seeMyFeed",
    defaultMessage: "See My Feed",
    description: "See My Feed button"
  },
  "seeAll": {
    id: "dashboard.page.seeAll",
    defaultMessage: "See All",
    description: "See All button"
  },
  "upcomingEvents": {
    id: "dashboard.page.upcomingEvents",
    defaultMessage: "Upcoming Events",
    description: "Upcoming Events title"
  },
  "courses": {
    id: "dashboard.page.courses",
    defaultMessage: "Courses",
    description: "Courses title"
  },
  "programs": {
    id: "dashboard.page.programs",
    defaultMessage: "Programs",
    description: "Programs title"
  },
  askAnything: {
    id: 'learning.chat.input.placeholder',
    defaultMessage: 'Ask anything about your courses...',
    description: 'Placeholder text for chat input',
  },
  howCanIHelp: {
    id: 'learning.chat.suggestions.title',
    defaultMessage: 'How can I help you today?',
    description: 'Title for suggestions view',
  },
  lastAccessed: {
    id: 'learning.chat.xblock.lastAccessed',
    defaultMessage: 'Last accessed: {date}',
    description: 'Last accessed date for xblock content',
  },
  suggestTopic: {
    id: 'learning.chat.suggestions.suggestTopic',
    defaultMessage: 'Suggest a Topic',
    description: 'Suggestion text for suggesting a topic',
  },
  showProgress: {
    id: 'learning.chat.suggestions.showProgress',
    defaultMessage: 'Show my progress',
    description: 'Suggestion text for showing learning progress',
  },
  upcomingDeadlines: {
    id: 'learning.chat.suggestions.upcomingDeadlines',
    defaultMessage: 'Upcoming deadlines',
    description: 'Suggestion text for showing upcoming deadlines',
  },
  reportProblem: {
    id: 'learning.chat.suggestions.reportProblem',
    defaultMessage: 'Report a Problem',
    description: 'Suggestion text for reporting a problem',
  },
  suggestTopicAction: {
    id: 'learning.chat.suggestions.suggestTopicAction',
    defaultMessage: 'Suggest me a topic which I can learn for the day.',
    description: 'Action text for suggesting a topic',
  },
  showProgressAction: {
    id: 'learning.chat.suggestions.showProgressAction',
    defaultMessage: 'I want to see my progress',
    description: 'Action text for showing learning progress',
  },
  upcomingDeadlinesAction: {
    id: 'learning.chat.suggestions.upcomingDeadlinesAction',
    defaultMessage: 'I want to see my upcoming deadlines',
    description: 'Action text for showing upcoming deadlines',
  },
  reportProblemAction: {
    id: 'learning.chat.suggestions.reportProblemAction',
    defaultMessage: 'Report a Problem',
    description: 'Action text for reporting a problem',
  },
  homeView: {
    id: 'learning.chat.suggestions.homeView',
    defaultMessage: 'Home',
    description: 'Home button text',
  },
  aiHomeView: {
    id: 'learning.chat.suggestions.aiHomeView',
    defaultMessage: 'AI Home',
    description: 'AI Home button text',
  },
  noEventsFound: {
    id: 'dashboard.page.noEventsFound',
    defaultMessage: 'No events found',
    description: 'No events found message',
  },
  // AI Tutor Header
  aiTutor: {
    id: 'learning.aiTutor',
    defaultMessage: 'AI Tutor',
    description: 'Title for the AI Tutor section',
  },
  alwaysHereToHelp: {
    id: 'learning.alwaysHereToHelp',
    defaultMessage: 'Always here to help',
    description: 'Subtitle for the AI Tutor section',
  },
  suggestedQuestions: {
    id: 'learning.suggestedQuestions',
    defaultMessage: 'Suggested Questions',
    description: 'Title for the suggested questions section',
  },
  welcome: {
    id: 'learning.welcome',
    defaultMessage: 'Welcome',
    description: 'Title for the welcome section',
  },
  welcomeDescription: {
    id: 'learning.welcomeDescription',
    defaultMessage: 'I can help you with your courses. Here are some topics you can learn about.',
    description: 'Description for the welcome section',
  },

  // Chat Input
  askAnything: {
    id: 'learning.chat.askAnything',
    defaultMessage: 'Ask anything about your courses...',
    description: 'Placeholder text for the chat input field',
  },
  noRecentActivity: {
    id: 'dashboard.page.noRecentActivity',
    defaultMessage: 'No recent activity',
    description: 'No recent activity message',
  },
});

export default messages;